import axiosInstance from "../../axiosClientDMS";

export const getDeviceStatusCount = async (
  tcCode: any,
  siteCode: any,
  blockCode: any,
  signal: any
) => {
  const res = await axiosInstance.get(`/dmsapp/Device/DeviceStatusCount`, {
    params: { tcCode, siteCode, blockCode },
    signal,
  });

  return res?.data?.data;
};
